import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { EmailTemplate } from './email-template'
import { EmailTemplateSerializer } from './email-template.serializer'
import { Observable } from 'rxjs'

@Injectable()
export class EmailTemplateService extends ResourceService<EmailTemplate> {
  constructor(
    public http: HttpClient,
    emailTemplateSerializer: EmailTemplateSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/email-templates`,
      emailTemplateSerializer
    )
  }

  public sendTestById(id: number, toEmail: string): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/email-templates/${id}/test`,
      { toEmail }
    )
  }
}
